import React from "react";
import {
  GOVGR_BODY,
  GOVGR_GRID_COLUMN_TWO_THIRDS,
  GOVGR_HEADING_XL,
  GOVGR_MAIN_WRAPPER,
  GOVGR_WIDTH_CONTAINER,
} from "../../conf/styles/GovGr500Page";

const GovGr500Page = ({
  translations = {
    heading: "Λυπούμαστε, παρουσιάστηκε σφάλμα",
    p1: "Υπάρχει ένα τεχνικό πρόβλημα. Παρακαλώ προσπαθήστε ξανά αργότερα.",
  },
}) => {
  return (
    <div class={`${GOVGR_WIDTH_CONTAINER}`}>
      <div class={`${GOVGR_MAIN_WRAPPER}`}>
        <main class={`${GOVGR_GRID_COLUMN_TWO_THIRDS}`}>
          <h1 class={`${GOVGR_HEADING_XL}`}>{translations.heading}</h1>
          <p class={`${GOVGR_BODY}`}>{translations.p1}</p>
        </main>
      </div>
    </div>
  );
};

export default GovGr500Page;
